import { render, staticRenderFns } from "./MessagesButton.vue?vue&type=template&id=1cd83fe6&scoped=true"
import script from "./MessagesButton.vue?vue&type=script&lang=js"
export * from "./MessagesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd83fe6",
  null
  
)

export default component.exports